export default __webpack_public_path__ + "static/media/remove-item.f4c0c6aa.svg";